import React from 'react';
import { Button, Form, Modal, Icon, Select, message } from 'antd';
import { isNotOverStep1 } from "./../util";
import MoneyInput from './../MoneyInput';
import TargetAccount from './../TargetAccount';
import BankAccount from './../BankAccount';
import SecondStep from './SecondStep';
import { formItemLayout, tailFormItemLayout } from '$ACTIONS/constantsData';
import { ApiPort } from '$ACTIONS/TLCAPI';
import { CommonPostPay, GetPayList } from '$DATA/wallet';
import { formatSeconds, dateFormat } from '$ACTIONS/util';
import { sendPiwikUrl, sendPiwikEvent } from '$ACTIONS/PiwikUtil';
import { Cookie, ExpirableLocalStorage } from '$ACTIONS/helper';
import DepositNameKYCTrait from "$ACTIONS/trait/DepositNameKYCTrait";
import UploadFile from '@/UploadFile';
import FinishStep from '../FinishStep/';
import moment from 'moment';
import PaymentProgressModal, { renderP115001Content, P115001onOkFunc, triggerPercentPiwik } from "../../Loading";
const { Item } = Form;
const { Option } = Select;

class ODP extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			bankCodeState: '', // 存款銀行Code值
			targetValue: '', // 目标账户State值
			targetName: '', // 目标账户名称
			bonusVal: 0, // 可申请优惠Val值
			bonusName: '', // 可申请优惠名称
			lbStep: 1, // 网银转账充值步骤
			uploadFileName: '',
			channelType: '',
			remainingTime: '00:00', // 剩余时间
			needShowP115001: true,
			paymentProgressModalPercent: 0,
			visible: false
		};

		this.DepositNameKYCTrait = DepositNameKYCTrait(this);
		this.DepositNameKYCTrait.init();

		this.payTypeCode = 'ODP'; // 当前支付方式Code
		this.timeTimer = null; // 网银转账第二步骤倒计时Timer
		this.collectionInfo = null;
		this.goThirdStep = null; // 前往第三部的方法
		this.transactionId = null;
		this.hasTimeoutSeconds = 0; //detail api返回倒计时时间
		this.setPaymentProgressModalPercent = this.setPaymentProgressModalPercent.bind(this);
		this.setNeedShowP115001False = this.setNeedShowP115001False.bind(this);
	}
	setPaymentProgressModalPercent(p) { this.setState({paymentProgressModalPercent: p}) }
	setNeedShowP115001False() { this.setState({needShowP115001: false}) }
	componentDidMount() {
		// 设置在线支付的默认值
		// this.props.bcTypeList.length && this.props.changeBcType(this.props.bcTypeList[0].code, true);
	}
	componentDidUpdate(prevProps, prevState) {
		// 本银充值第三步骤记录
		if (prevState.lbStep !== this.state.lbStep) {
			if (this.state.lbStep === 2) {
				this.startCountDown(this.hasTimeoutSeconds ? this.hasTimeoutSeconds : 300);
			}
			if (this.state.lbStep === 3) {
				this.startCountDown(600);
			}

			this.props.setPromoBannerVisible && this.props.setPromoBannerVisible(
				isNotOverStep1(this.state.lbStep, 'lbStep'));

		}
	}
	componentWillUnmount() {
		ExpirableLocalStorage.Delete('dateTime')
		clearInterval(this.timeTimer);
		this.hasTimeoutSeconds = 0;
	}
	goLbHome = () => {
		clearInterval(this.timeTimer);
		this.setState({ lbStep: 1 });
	};
	startCountDown = (countTime) => {
		clearInterval(this.timeTimer);
		let cache = ExpirableLocalStorage.Get('dateTime');
		if (!cache) {
			cache = moment().format('YYYY-MM-DD HH:mm:ss');
			ExpirableLocalStorage.Create('dateTime', cache, this.hasTimeoutSeconds + 20); // re-setup
		}
		const depositDateTime = cache.replace('-', '/').replace('-', '/');
		let lastSeconds = countTime - (new Date().getTime() - new Date(depositDateTime).getTime()) / 1000;
		this.timeTimer = setInterval(() => {
			if (lastSeconds <= 0) {
				if (this.state.lbStep === 2) {
					Modal.confirm({
						icon: null,
						centered: true,
						closable: false,
						className: 'confirm-modal-of-public up-yes-bottom-no-block-btns-modal hide-ant-modal-close-x-modal modal-show-blue-cancel-button',
						title: '温馨提醒',
						content: <div style={{ textAlign: 'center' }}>您是否已经成功存款？</div>,
						okText: '是，我已经成功存款',
						cancelText: '否，我想提交新交易',
						onOk: () => {
							this.goThirdStep();
						},
						onCancel: () => {
							ExpirableLocalStorage.Delete('dateTime');
							this.setState({ lbStep: 1 });
						}
					});
				} else {
					this.setState({ lbStep: 1 });
				}
				clearInterval(this.timeTimer);
			}
			this.setState({ remainingTime: formatSeconds(lastSeconds--) });
		}, 1000);
	};
	payConfirm = (e) => {
		e.preventDefault();
		const Paybank =
			this.props.currDepositDetail.banks &&
			this.props.currDepositDetail.banks.find((v) => v.Code === this.state.bankCodeState);
		// if (Paybank == undefined) {
		// 	return message.error('正在维护，请选择其他存款方式。');
		// }
		if (typeof this.props.depositStatusCheck(this.props.bcType, this.state.bankCodeState) === 'undefined') return; // 未完成真实姓名验证则呼出完善弹窗
		this.depositName = this.props.form.getFieldValue('accountHolderName');
		this.props.form.validateFields((err, values) => {
			if (!err) {
				if (!this.state.visible) {
					Pushgtagdata(`Deposit`, 'Submit', 'Submit_OneDeposit_DepositPage');
				}
				Cookie.Create('loadingTime', dateFormat(), { expires: 1.67 });
				this.setProgressModalVisible(true, {needShowP115001:true});
				// triggerPercentPiwik.didRun = false;
				let accountHolderName = this.depositName != null
								? this.depositName
								: JSON.parse(localStorage.getItem('memberInfo')).firstName;
				let { setting } = this.props.currDepositDetail;
				if (setting?.showDepositorNameField === false && setting?.prefillRegisteredName === false) {
						accountHolderName = "";
				}
				CommonPostPay(
					{
						methodcode: this.refs.Channeldefault.state.Channeldefault,
						accountHolderName,
						accountNumber: '0',
						amount: values.money,
						bankName: '', // (copy mobile logic) Paybank ? Paybank.code : '',
						bonusCoupon: '', // values.bonusCode || '',
						cardExpiryDate: '',
						cardName: '',
						cardNumber: '',
						cardPIN: '',
						charges: 0,
						couponText: '',
						depositingBankAcctNum: '',
						depositingWallet: this.state.targetValue, // 目标账户Code
						domainName: ApiPort.LOCAL_HOST,
						fileBytes: '',
						fileName: '',
						isMobile: false,
						isPreferredWalletSet: false, // 是否设为默认目标账户
						isSmallSet: false,
						language: 'zh-cn',
						mgmtRefNo: 'Fun88Desktop',
						offlineDepositDate: '',
						offlineRefNo: '0',
						paymentMethod: 'ODP',
						refNo: '0',
						// secondStepModel: null, // need to remove for API spec
						successUrl: ApiPort.LOCAL_HOST,
						transactionType: 'Deposit',
						transferType: null,
						blackBoxValue: window.E2GetBlackbox
							? window.E2GetBlackbox().blackbox == '' || window.E2GetBlackbox().blackbox == undefined
								? ''
								: window.E2GetBlackbox().blackbox
							: '',
						e2BlackBoxValue: window.E2GetBlackbox
							? window.E2GetBlackbox().blackbox == '' || window.E2GetBlackbox().blackbox == undefined
								? ''
								: window.E2GetBlackbox().blackbox
							: ''
					},
					(res) => {
						this.setState({ visible: false, channelType: res?.result?.channelType });
						triggerPercentPiwik(this.state.paymentProgressModalPercent);
						if (!res.isSuccess) {
							let _title = '温馨提醒';
							let _okText = '知道了';
							let _content = '';
							let _onOkFunc = undefined;
							let _modalWidth = undefined;
							let _hasExchangeHintClassName = true;
							const IS_ERR_P101116 = errCode==='P101116';
							const IS_ERR_P101053 = errCode==='P101053';
							const IS_ERR_P101019 = errCode==='P101019';
							const IS_ERR_P101017 = errCode==='P101017';
							const IS_ERR_P115001 = errCode==='P115001';
							const IS_ERR_P103001 = errCode==='P103001';
							if (errCode) {
								// setup _title _okText
								if (IS_ERR_P101116 || IS_ERR_P101053) {
									_title = '重要提示';
									_okText = '好的';
								} else if (IS_ERR_P115001) {
									_title = '温馨提醒';
									_okText = '重新提交';
									_modalWidth = 400;
									_hasExchangeHintClassName = false;
								}
								// setup _content _onOkFunc
								if (IS_ERR_P103001) {
									_content = <p>当前交易繁忙，推荐使用USDT存款方式，体验极致存款速度，安全安心。</p>;
								} else if (IS_ERR_P115001) {
									if (!this.state.needShowP115001) {return;}
									sendPiwikUrl(`ODP_deposit_error_popup`, `ODP Deposit Error Popup`);
									_onOkFunc = P115001onOkFunc;
									this.props.setLoading(true);
									GetPayList(paylistRes=>{
									this.props.setLoading(false);
									_content = renderP115001Content(paylistRes, this.props.setCurrentPayMethod);
									if(this.state.needShowP115001) { _popupErrorModal(); }
									}, ()=>{
									this.props.setLoading(false);
									_content = renderP115001Content();
									if(this.state.needShowP115001) { _popupErrorModal(); }
									});
									return;
								} else if (IS_ERR_P101019 || IS_ERR_P101017) {
									// use `description`
									_content = res && res.errors && res.errors.length && res.errors[0].description && (<p>{res.errors[0].description}</p>);
								} else if (IS_ERR_P101116 || IS_ERR_P101053) {
									// if (errCode==='P101116') {
									// 	_onOkFunc = () => {
											// goToDepositDefaultWith1stMethodSelected TODO:need?
									// 	};
									// }
									let displayLastDepositAmount = n => {
										let s = n.toString().replace(/0+$/g, ''); // right-trim for 0
										if (s.substr(s.length-1)=='.') { // remove '.' if last character is '.'
											s = s.substr(0,s.length-1)
										}
										return s;
									};
									_content = (<React.Fragment><p>请耐心等待，您有一项存款申请正在处理中</p>
										<div className="OrderContent" style={{margin:0}}>
											<p>存款编号：{res.result ? res.result.lastDepositID : ''}</p>
											<p>存款金额：￥ {res.result ? displayLastDepositAmount(res.result.lastDepositAmount) : ''}</p>
										</div>
										{IS_ERR_P101116
											? <p>请等待处理完毕后，再提交其他存款申请</p>
											: <div className="modal-prompt-info">注意：不允许重复提交相同金额，请提交其他金额进行存款。</div>}
										</React.Fragment>);
								}
							}
							if (!_content) {
								if (res && res.errors && res.errors.length
									&& (res.errors[0].description||res.errors[0].message||res.errors[0].errorCode)
									) {
									// Try to display readable content for user
									_content = (res.errors[0].description ? res.errors[0].description : '')
														+ (res.errors[0].message ? (' ' + res.errors[0].message) : '')
														+ (res.errors[0].errorCode ? (' (' + res.errors[0].errorCode) + ')' : '')
								} else {
									// Display unexpected error using JSON directly
									_content = 'unknow error: ' + JSON.stringify(res)
								}
							}
							function _popupErrorModal() {
							Modal.info({
								className: 'confirm-modal-of-public' + (IS_ERR_P115001 ? ' suggestion-list-when-no-ODP-banks-modal hide-ant-modal-close-x-modal' : ''),
								icon: <div />,
								title: _title,
								width: _modalWidth || 355,
								okText: _okText,
								okButtonProps: {
									shape: 'round'
								},
								onOk: _onOkFunc,
								content: (
									<div className={(_hasExchangeHintClassName ? "exchange-hint " : "")+"ODPmodals"}>
										<div className="content" style={{ textAlign: 'left' }}>
											{_content}
										</div>
									</div>)
							});
							}
							_popupErrorModal();
							return;
						}
						// START res.isSuccess === true
						res = res.result;
						if (res && res.returnedBankDetails && res.returnedBankDetails.bankName
							&& (!res.vendorDepositBankDetails || !res.vendorDepositBankDetails.bankName)
							) {
							for (let item of [
								['bankAccountNumber', 'accountNumber'],
								['bankAccountName', 'accountHolderName'],
								['bankProvince', 'province'],
								['bankCity', 'city'],
								['bankBranch', 'branch'],
							]) {
								res.returnedBankDetails[item[0]] = res.returnedBankDetails[item[1]];
								delete res.returnedBankDetails[item[1]];
							}
							// res.isReturnedBank = true;
							res.vendorDepositBankDetails = res.returnedBankDetails; // assign to vendorDepositBankDetails
							res.isReturnedBankDetails = true;
						}
						this.collectionInfo = res;

							const { currDepositDetail } = this.props;
							this.hasTimeoutSeconds = 300; // ODP always 5min
							/* ODP always 5min
							let minute = 5,
								second = '';
							if (
								currDepositDetail &&
								currDepositDetail.setting &&
								currDepositDetail.setting.timeoutSeconds &&
								currDepositDetail.setting.timeoutSeconds > 0
							) {
								//detial api有返回倒计时数就用api返回的，没有返回就用写死的。
								this.hasTimeoutSeconds = currDepositDetail.setting.timeoutSeconds;
								minute = parseInt(currDepositDetail.setting.timeoutSeconds / 60)
									? parseInt(currDepositDetail.setting.timeoutSeconds / 60) + '分钟'
									: '';
								second = parseInt(currDepositDetail.setting.timeoutSeconds % 60)
									? parseInt(currDepositDetail.setting.timeoutSeconds % 60) + '秒'
									: '';
							}
							*/

							//放棄submittedAt 改用 用戶當前時間
							ExpirableLocalStorage.Create('dateTime', moment().format('YYYY-MM-DD HH:mm:ss'), this.hasTimeoutSeconds + 20);
							this.setState({lbStep: 2, FinishData: res});

					}, {IS_ALREADY_HANDLE_SUCCESS_FALSE_UI_UX: true /*ticket2144*/, caller: this}, {IS_STILL_RETURN_JSONVALUE_IF_HTTP4xx5xx: true}
				);
			}
		});

		Pushgtagdata('Deposit', 'Submit', 'Submit_OneDeposit_Deposit');
	};
	goUserCenterRecords = () => {
		this.goLbHome();
		this.props.onCancel();
		this.props.goUserCenter('records');
		sessionStorage.setItem('selectTabKey', 'deposit');
		typeof global.changeRecordFilterType === 'function' && global.changeRecordFilterType('deposit');
	};

	submitBtnEnable = () => {
		let { setting } = this.props.currDepositDetail;
		let errors = Object.values(this.props.form.getFieldsError()).some((v) => v !== undefined);
		let values = Object.values(this.props.form.getFieldsValue()).some((v) => v == '' || v == undefined);
		if (setting && setting.showDepositorNameField && !setting.prefillRegisteredName) {
			return !values && this.props.form.getFieldValue('money') !== '' && !errors;
		}
		return this.props.form.getFieldValue('money') !== '' && !errors;
	};

	goToODPDefault = from => { // follow whimsical
		if (from==='SECOND_STEP_CANCEL_BTN') {
			this.props.form.resetFields(); // https://stackoverflow.com/questions/70187652
			this.setState({lbStep: 1})
		}
	}

    setProgressModalVisible = (visible, other={}) => {
        let o = { visible };
        o = {...o, ...other};
        this.setState(o);
    }

	render() {
		let { setting, banks } = this.props.currDepositDetail; // 当前支付方式的详情

		const {
			getFieldsError,
			getFieldDecorator,
			getFieldValue,
			setFieldsValue,
			setFields,
			getFieldError
		} = this.props.form;
		const { bcTypeList } = this.props;
		const { bankCodeState, targetValue, bonusVal, lbStep, visible, Finish, FinishData } = this.state;

		console.log('真实姓名', getFieldValue('accountHolderName'));
		return (
			<React.Fragment>
				{visible && (
					<PaymentProgressModal
						setLoading={this.props.setLoading}
						setPaymentProgressModalPercent={this.setPaymentProgressModalPercent}
						setNeedShowP115001False={this.setNeedShowP115001False}
						visible={visible}
						visualStyle={'visualstyle2'}
                        setVisible={this.setProgressModalVisible}
                        setCurrentPayMethod={this.props.setCurrentPayMethod}
					/>
				)}

				<Form
					className="form-wrap"
					style={{ display: lbStep === 1 ? 'block' : 'none' }}
					{...formItemLayout}
					onSubmit={this.payConfirm}
				>
					<div
						className="modal-prompt-info"
						style={{
							display: this.props.isShowBankCardVerif ? 'block' : 'none',
							color: '#2962FF',
							textAlign: 'center',
							cursor: 'pointer'
						}}
						onClick={() => this.props.openBankAccountVerif()}
					>
						<span className="spanText">开启更多充值和提现方式</span>
						<p className="pText">点击上方按钮完成验证，小同为您承担网银转账 5% 手续费</p>
					</div>
					<MoneyInput
						{...this.props.dialogTabKey}
						getFieldDecorator={getFieldDecorator}
						antForm={this.props.form}
						payTypeCode={this.payTypeCode}
						payMethodList={this.props.payMethodList}
						setCurrDepositDetail={this.props.setCurrDepositDetail}
						setting={setting}
						setFieldsValue={setFieldsValue}
						setLoading={this.props.setLoading}
						ref="Channeldefault"
						setFields={setFields}
						getFieldError={getFieldError}
						getFieldValue={getFieldValue}
					/>

					{banks &&
					banks != '' && (
						<BankAccount
							keyName={[ 'name', 'code' ]}
							isAutoAssign={setting && setting.isAutoAssign}
							bankAccounts={banks}
							bankCodeState={bankCodeState}
							setBankCode={(v) => {
								this.setState({ bankCodeState: v });
							}}
						/>
					)}
					<TargetAccount
						{...this.props.dialogTabKey}
						getFieldDecorator={getFieldDecorator}
						getFieldValue={getFieldValue}
						setLoading={this.props.setLoading}
						targetValue={targetValue}
						setTargetValue={(v, name) => {
							this.setState({ targetValue: v, targetName: name });
						}}
						bonusVal={bonusVal}
						setBonusValue={(v, name) => {
							this.setState({ bonusVal: v, bonusName: name });
						}}
					/>
					<Item {...tailFormItemLayout}>
						<div className="btn-wrap">
							<Button
								disabled={
									// Object.values(getFieldsError()).some(
									//     (v) => v !== undefined
									// )
									!this.submitBtnEnable()
								}
								// disabled={
								//     Object.values(getFieldsError()).some(
								//         (v) => v !== undefined
								//     ) ||
								//     !getFieldValue("money") ||
								//     !getFieldValue("accountHolderName")
								//     // ||
								//     // (bankAccounts && bankAccounts.length == 0)
								// }
								size="large"
								type="primary"
								htmlType="submit"
								block
							>
								提交
							</Button>
						</div>
					</Item>
				</Form>
				{/* 第二步骤 */}
				<SecondStep
					lbStep={lbStep}
					goToODPDefault={this.goToODPDefault}
					setLbStep={(v) => {
						this.setState({ lbStep: v });
					}}
					setLoading={this.props.setLoading}
					collectionInfo={this.collectionInfo}
					remainingTime={this.state.remainingTime}
					setGoThirdStep={(v) => {
						this.goThirdStep = v;
					}}
					hasTimeoutSeconds={this.hasTimeoutSeconds}
					isDepositReceiptRequired={FinishData?.channelTypeIsMandatoryUploadSlip}
				/>
				{/* 第三步骤 */}
				{/* 成功提交的页面 */}
				{lbStep === 3 && (
					<FinishStep
						collectionInfo={FinishData}
						Time={'30:00'}
						goRecord={() => {
							this.goUserCenterRecords();
						}}
						goHome={() => {
							this.props.onCancel('ToHome');
						}}
						payTypeCode={'ODP'}
						uploadFile={true}
						isSeparatedWithFileUpload={true}
						isDepositReceiptRequired={FinishData.channelTypeIsMandatoryUploadSlip}
						setLbStep3={() => {
							this.setState({ lbStep: 3 });
						}}
					/>
				)}
				{/* goUserCenterRecords */}
				{/* <div style={{ display: lbStep === 3 ? 'block' : 'none' }}>
					<div className="lb-third-step-wrap">
						<Icon type="check-circle" theme="filled" />
						<div className="check-success">
							<div>提交成功</div>
							<div className="cuccess">{this.state.remainingTime}</div>
						</div>
						<p style={{ marginBottom: 14 }}>交易需要一段时间，请稍后再检查您的目标账户。</p>
						<div className="tlc-deposit-receipt radius">
							<ul>
								<li className="item-wrap upload-wrapper">
									<h2>上传收据（推荐使用）</h2>
									<span className="item-label">小同建议 直接上传充值收据以便加快充值审核哦！</span>
									{!!this.state.uploadFileName ? (
										<Button block>{this.state.uploadFileName}</Button>
									) : (
										<UploadFile
											paymentType={this.payTypeCode}
											transactionId={this.transactionId}
											uploadFileName={this.state.uploadFileName}
											setFileName={(v) => {
												this.setState({ uploadFileName: v });
											}}
											children={
												<Button block className="link">
													上传
												</Button>
											}
										/>
									)}
									<span className="item-label" style={{ padding: 0 }}>
										若您无法上传收据，请联系<Button
											className="inline"
											type="link"
											onClick={global.PopUpLiveChat}
										>
											在线客服
										</Button>。
									</span>
								</li>
							</ul>
						</div>
						<div className="btn-wrap">
							<Button
								size="large"
								type="primary"
								htmlType="submit"
								onClick={this.goUserCenterRecords}
								block
							>
								查看交易记录
							</Button>
						</div>
					</div>
				</div> */}
				<div className="deposit-help-wrap" style={{ display: lbStep === 3 ? 'none' : 'block' }}>
					<h4>乐天使温馨提醒：</h4>

					<ul>
						<li>请确保您的存款金额与输入的金额一致，并且建议您上传存款凭证，以利及时到账。 ​ </li>
						<li>请确保您的账户正确，勿存款到旧账户，且不要重复提交，以免导致系统记录异常而无法成功到账。 ​</li>
						<li>银行账号会不定期更换，请确保您使用的是存款页面上最新的账号，再进行转账。​</li>
						{/* <li>
							​如有任何问题请联系
							<Button type="link" className="inline" onClick={global.PopUpLiveChat}>
								在线客服
							</Button>
							。
						</li> */}
					</ul>
				</div>
			</React.Fragment>
		);
	}
}
export default Form.create({ name: 'ODP' })(ODP);
